export default __webpack_public_path__ + "static/media/pic3.aaa9e904.svg";